import React, {useContext, useEffect, useMemo, useState} from "react";
import {Link, useParams} from "react-router-dom";
import {UserContext} from "../../App";
import {
  getEstimatePdfBase64,
  pdfBase64ToBlob,
} from "../../store/actions/estimateActions";
import {estimateStatus} from "./estimateContent";
import {
  useExistingObject,
  useTarifsOptions,
} from "../../utils/estimate-invoice";
import CreateOrUpdateContentForm from "../../utils/estimate-invoice/CreateOrUpdateContentForm";
import Footer from "../../utils/estimate-invoice/Footer";
import {NavItem, NavTabs} from "../layout/Nav";

export default function EstimateAddContent() {
  const params = useParams();
  const estimateId = params.estimateId;

  const {userInfos} = useContext(UserContext);

  const [estimatePdfBase64, setEstimatePdfBase64] = useState(null);
  const [activeTab, setActiveTab] = useState("bookings");
  const [loading, setLoading] = useState(false);

  // When Updating an estimate

  const tarifs = useTarifsOptions();
  const estimateRaw = useExistingObject({
    userInfos,
    tarifs,
    objectId: estimateId,
    isEstimate: true,
  });

  // region pdf generation
  useEffect(() => {
    if (estimateRaw && estimateRaw?.id && estimateRaw?.status !== "draft") {
      getEstimatePdfBase64(estimateRaw?.id, userInfos.jwt)
        .then((pdf) => {
          setEstimatePdfBase64(pdf);
        })
        .catch((error) => {
          // Silently handle errors - don't show error 500
          console.error("Error loading estimate PDF:", error);
          setEstimatePdfBase64(null);
        });
    }
  }, [estimateRaw, estimateRaw?.id, estimateRaw?.status, userInfos.jwt]);

  const pdfObjectUrl = useMemo(() => {
    if (estimatePdfBase64) {
      const blob = pdfBase64ToBlob(estimatePdfBase64);
      return URL.createObjectURL(blob);
    }

    return null;
  }, [estimatePdfBase64]);

  // endregion

  const Status = useMemo(() => {
    if (!estimateRaw) return "";
    else if (estimateRaw.status === "invoiced") {
      return (
        <>
          {" "}
          ({estimateStatus[estimateRaw.status]} :{" "}
          <Link to={"/invoices/" + estimateRaw.invoice}>
            {estimateRaw.invoice}
          </Link>
          )
        </>
      );
    }

    return <> ({estimateStatus[estimateRaw.status]})</>;
  }, [estimateRaw]);

  return (
    <div
      className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader   kt-grid__item" id="kt_subheader">
        <div className="kt-container  kt-container--fluid ">
          <div className="kt-subheader__main">
            <h3 className="kt-subheader__title">
              {estimateId ? "Détails du devis" : "Créer un devis"}
            </h3>
            <div className="kt-subheader__breadcrumbs">
              <Link to="/" className="kt-subheader__breadcrumbs-home">
                <i className="flaticon2-shelter"></i>
              </Link>
              <span className="kt-subheader__breadcrumbs-separator"></span>
              <Link to="/estimates" className="kt-subheader__breadcrumbs-link">
                Devis
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div className="kt-portlet kt-portlet--tabs">
          <div className="kt-portlet__head">
            <div className="kt-portlet__head-label">
              <h3 className="kt-portlet__head-title">
                {estimateId ? (
                  <>
                    Devis n° {estimateId} {Status}
                  </>
                ) : (
                  <>Créer un devis</>
                )}
              </h3>
            </div>
          </div>
          <NavTabs className="titles m-4">
            <NavItem className={activeTab === "bookings" ? "active" : ""}>
              <button onClick={() => setActiveTab("bookings")}>
                Courses
              </button>
            </NavItem>
            {estimateId && estimateRaw && estimateRaw.status !== "draft" && (
              <NavItem className={activeTab === "infos" ? "active" : ""}>
                <button onClick={() => setActiveTab("infos")}>
                  PDF
                </button>
              </NavItem>
            )}
          </NavTabs>
          <div className="tab-content">
            <div
              style={{display: activeTab === "bookings" ? "block" : "none"}}
            >
              <CreateOrUpdateContentForm
                rawObject={estimateRaw}
                tarifs={tarifs}
                isEstimate={true}
                loading={loading}
                setLoading={setLoading}
              />
            </div>
            <div style={{display: activeTab === "infos" ? "block" : "none"}}>
              <div className="d-flex justify-content-center">
                <embed src={pdfObjectUrl} height="900px" width="600px"/>
              </div>
              <Footer
                rawObject={estimateRaw}
                loading={loading}
                setLoading={setLoading}
                isEstimate={true}
                readOnly={estimateRaw?.id && estimateRaw?.status !== "draft"}
                createButton={null}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
